<template>
  <div class="foot">
    <div class="footer">
      <div class="item" :class=" path === item.path ? 'active' : ''" @click="pathChange(item.path)" v-for="(item, index) in footList" :key="index">
        <div class="icon">
          <i class="iconfont" :class="[item.icon]"></i>
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    path: String,
  },
  data() {
    return {

    };

  },
  computed: {
    footList() {
      return [
        {
          icon: 'icon-jingzhunyingxiao',
          path: "/home",
          name: this.$t('foot.nav1')
        }, {
          icon: 'icon-shuju',
          path: "/market",
          name: this.$t('foot.nav2')
        }, {
          icon: 'icon-jiaoyi',
          path: "/market/second",
          // name: this.$t('params.transType1')
          name: this.$t('assets.second')
        }, {
          icon: 'icon-shejiaotubiao-69',
          // path: "/market/second",
          path: "/trade/trade",
          // name: this.$t('assets.second')
          name: this.$t('foot.nav4')
        }, {
          icon: 'icon-qianbaozhifumaijia',
          path: "/assets",
          name: this.$t('foot.nav5')
        }
      ]
    }
  },

  methods: {
    pathChange(path) {
      this.$router.push(path)
    }
  },
};
</script>

<style lang="less" scoped>
.foot {
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.33);
  padding-top: 10px;
  // background-color: rgb(16, 23, 31);
  background-color: #fff;
  padding: 20px;

  .footer {
    display: flex;

    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;


      .icon {
        .iconfont {
          font-size: 30px !important;
          // color: var(--color-theme-grey);
          color: #ccc;
        }
      }

      .name {
        font-size: 24px;
        line-height: normal;
        margin-top: 6px;
        padding-bottom: 6px;
      }

      &.active {
        color: #0052ff;

        .icon {
          .iconfont {
          color: #0052ff;

          }
        }

      }
    }
  }
}
</style>
